<main>
  <h2>{{ "MAIN_APP_CAMERA.meineNächstenTermine" | translate }}</h2>
    <mat-card class="card-margin" *ngFor="let termin of terminZeilen">
      <div class="list-item-layout" *ngIf="innerWidth > 480">
        <div class="list-item-first-box" [class.small-font]="innerWidth <= 480">
          <div class="black">{{termin.terminStart | datumFormat}}</div>
          <div class="gray">{{termin.terminEnde | datumFormat}}</div>
        </div>
         <div class="list-box">
            <div class="black">{{termin.description}}</div>
         </div>
         <div class="list-box" (click)="showDetails(termin)">
          <div class="link">{{ "MOBILE_APP.MY_APPOINTMENTS.DISPLAY_INFOS" | translate }}</div>
         </div>
         <div class="list-box flex-box">
          <button mat-mini-fab class="vinavonButton" (click)="showTerminDetail(termin)">
            <mat-icon style="margin: 0;">edit</mat-icon>
          </button>
         </div>
      </div>


      <div class="list-item-layout-mobile" *ngIf="innerWidth <= 480">
        <div class="list-item-first-box-mobile">
          <div class="black small-font">{{termin.terminStart | datumFormat}}</div>
          <div class="gray small-font">{{termin.terminEnde | datumFormat}}</div>
        </div>

        <div class="list-box-mobile">
          <div class="black">{{termin.description}}</div>
          <div class="link" (click)="showDetails(termin)">{{ "MOBILE_APP.MY_APPOINTMENTS.DISPLAY_INFOS" | translate }}</div>
        </div>

        <div class="list-box flex-box">
          <button mat-mini-fab class="vinavonButton" (click)="showTerminDetail(termin)">
            <mat-icon style="margin: 0;">edit</mat-icon>
          </button>
         </div>

      </div>
    </mat-card>
  </main>

